var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "manager_dashboard" },
    [
      _c("user-menu"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrapper", staticStyle: { "background-color": "#FFF" } },
        [
          _vm.checkIsMentee()
            ? _c("mentee-sidebar-menu", {
                attrs: { show_menu: true, show_back_button: false }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.checkIsManager() ||
          (_vm.$store.state.switch_admin_username && !_vm.entepriseAdmin)
            ? _c("ManagerSidebarMenu", {
                attrs: {
                  show_menu: true,
                  show_back_button: false,
                  back_link: "managerReports"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.checkIsMentor()
            ? _c("MentorSidebarMenu", {
                attrs: {
                  show_menu: true,
                  show_back_button: false,
                  back_link: "mentorReports"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.checkIsEnterprise() ||
          this.$store.state.switch_admin_enterprise_flag == 1
            ? _c("EnterprieSidebarMenu", {
                attrs: {
                  show_menu: true,
                  show_back_button: false,
                  back_link: "managerReports"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "content-wrapper",
              staticStyle: {
                "background-color": "#FFF",
                "padding-left": "165px"
              }
            },
            [
              _c(
                "div",
                { staticClass: "container-wrapper center" },
                [
                  _c(
                    "div",
                    { staticStyle: { "text-align": "center" } },
                    [
                      _c("flash-message", {
                        attrs: { autoHide: "", variant: "success" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-alert",
                    {
                      attrs: {
                        show: _vm.dismissCountDown,
                        dismissible: "",
                        variant: "success"
                      },
                      on: {
                        dismissed: function($event) {
                          _vm.dismissCountDown = 0
                        },
                        "dismiss-count-down": _vm.countDownChanged
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.success_message) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _vm.action == "view-profile"
                    ? _c("div", [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-6 pr-3 pr-xl-5" }, [
                            _c(
                              "div",
                              { staticClass: "shadow rounded px-3 py-3" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "row align-items-end" },
                                  [
                                    _c("div", { staticClass: "col-12" }, [
                                      _c("div", { staticClass: "row" }, [
                                        _vm._m(1),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-6 col-sm-3 col-md-3 col-lg-2 col-xl-3 text-right"
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "btn btn-primary btn-sm dbEditBtn",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.openEditProfileForm()
                                                  }
                                                }
                                              },
                                              [_vm._v("Edit")]
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "personal-details-wrapper"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "row grid_row" },
                                            [
                                              _vm._m(2),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-8 text-right"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "label_txt"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.first_name +
                                                            " " +
                                                            _vm.last_name
                                                        ) + " "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "row grid_row" },
                                            [
                                              _vm._m(3),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-8 text-right"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "label_txt"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.truncate(
                                                            _vm.email
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.phone_number != ""
                                            ? _c(
                                                "div",
                                                { staticClass: "row grid_row" },
                                                [
                                                  _vm._m(4),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-8 text-right"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "label_txt"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.phone_number
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", {
                              staticStyle: {
                                clear: "both",
                                "margin-bottom": "20px"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isUser(),
                                    expression: "isUser()"
                                  }
                                ],
                                staticClass: "shadow rounded px-3 py-3"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "row align-items-end" },
                                  [
                                    _c("div", { staticClass: "col-12" }, [
                                      _c("div", { staticClass: "row" }, [
                                        _vm._m(5),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-6 col-sm-3 col-md-3 col-lg-2 col-xl-3 text-right"
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "btn btn-primary btn-sm dbEditBtn",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.openCPAuthModal()
                                                  }
                                                }
                                              },
                                              [_vm._v("Edit")]
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "personal-details-wrapper"
                                        },
                                        [
                                          _vm._m(6),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "row grid_row" },
                                            [
                                              _vm._m(7),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-6 col-sm-3 col-md-3 col-lg-2 col-xl-3 text-right"
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass: "switch",
                                                      staticStyle: {
                                                        "margin-left": "10px",
                                                        padding: "0"
                                                      }
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.multifactor_authentication,
                                                            expression:
                                                              "multifactor_authentication"
                                                          }
                                                        ],
                                                        attrs: {
                                                          type: "checkbox"
                                                        },
                                                        domProps: {
                                                          checked:
                                                            _vm.multifactor_authentication,
                                                          checked: Array.isArray(
                                                            _vm.multifactor_authentication
                                                          )
                                                            ? _vm._i(
                                                                _vm.multifactor_authentication,
                                                                null
                                                              ) > -1
                                                            : _vm.multifactor_authentication
                                                        },
                                                        on: {
                                                          change: [
                                                            function($event) {
                                                              var $$a =
                                                                  _vm.multifactor_authentication,
                                                                $$el =
                                                                  $event.target,
                                                                $$c = $$el.checked
                                                                  ? true
                                                                  : false
                                                              if (
                                                                Array.isArray(
                                                                  $$a
                                                                )
                                                              ) {
                                                                var $$v = null,
                                                                  $$i = _vm._i(
                                                                    $$a,
                                                                    $$v
                                                                  )
                                                                if (
                                                                  $$el.checked
                                                                ) {
                                                                  $$i < 0 &&
                                                                    (_vm.multifactor_authentication = $$a.concat(
                                                                      [$$v]
                                                                    ))
                                                                } else {
                                                                  $$i > -1 &&
                                                                    (_vm.multifactor_authentication = $$a
                                                                      .slice(
                                                                        0,
                                                                        $$i
                                                                      )
                                                                      .concat(
                                                                        $$a.slice(
                                                                          $$i +
                                                                            1
                                                                        )
                                                                      ))
                                                                }
                                                              } else {
                                                                _vm.multifactor_authentication = $$c
                                                              }
                                                            },
                                                            function($event) {
                                                              return _vm.openAuthModal(
                                                                $event
                                                              )
                                                            }
                                                          ]
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass:
                                                          "slider round"
                                                      })
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", {
                              staticStyle: {
                                clear: "both",
                                "margin-bottom": "15px"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.isUser() &&
                                      !_vm.entepriseAdmin &&
                                      !_vm.researcher &&
                                      !_vm.csr,
                                    expression:
                                      "isUser() && !entepriseAdmin && !researcher && !csr"
                                  }
                                ],
                                staticClass: "shadow rounded px-3 py-3"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "row align-items-end" },
                                  [
                                    _c("div", { staticClass: "col-12" }, [
                                      _vm._m(8),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-12 p-0" }, [
                                        _c("div", {}, [
                                          _c(
                                            "div",
                                            { staticClass: "db-report-card" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "row" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-11 db_name_block"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "db-mentee-name"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                Communication\n                              "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols",
                                                          staticStyle: {
                                                            "padding-left":
                                                              "40px",
                                                            "padding-bottom":
                                                              "5px"
                                                          }
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.news_subscription_selected,
                                                                expression:
                                                                  "news_subscription_selected"
                                                              }
                                                            ],
                                                            ref:
                                                              "news_subscription",
                                                            staticStyle: {
                                                              "margin-top":
                                                                "4px",
                                                              height: "12px"
                                                            },
                                                            attrs: {
                                                              type: "checkbox",
                                                              id:
                                                                _vm.news_subscription,
                                                              name:
                                                                _vm.news_subscription
                                                            },
                                                            domProps: {
                                                              checked:
                                                                _vm.news_subscription_checked,
                                                              value: 1,
                                                              checked: Array.isArray(
                                                                _vm.news_subscription_selected
                                                              )
                                                                ? _vm._i(
                                                                    _vm.news_subscription_selected,
                                                                    1
                                                                  ) > -1
                                                                : _vm.news_subscription_selected
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.changeUserNewsSubscribe(
                                                                  $event
                                                                )
                                                              },
                                                              change: function(
                                                                $event
                                                              ) {
                                                                var $$a =
                                                                    _vm.news_subscription_selected,
                                                                  $$el =
                                                                    $event.target,
                                                                  $$c = $$el.checked
                                                                    ? true
                                                                    : false
                                                                if (
                                                                  Array.isArray(
                                                                    $$a
                                                                  )
                                                                ) {
                                                                  var $$v = 1,
                                                                    $$i = _vm._i(
                                                                      $$a,
                                                                      $$v
                                                                    )
                                                                  if (
                                                                    $$el.checked
                                                                  ) {
                                                                    $$i < 0 &&
                                                                      (_vm.news_subscription_selected = $$a.concat(
                                                                        [$$v]
                                                                      ))
                                                                  } else {
                                                                    $$i > -1 &&
                                                                      (_vm.news_subscription_selected = $$a
                                                                        .slice(
                                                                          0,
                                                                          $$i
                                                                        )
                                                                        .concat(
                                                                          $$a.slice(
                                                                            $$i +
                                                                              1
                                                                          )
                                                                        ))
                                                                  }
                                                                } else {
                                                                  _vm.news_subscription_selected = $$c
                                                                }
                                                              }
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "preference-heading",
                                                              attrs: {
                                                                for:
                                                                  "submit_comment_1"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "News, updates, promotions & more!"
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "db-mentee-name"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                Frequency\n                              "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols",
                                                          staticStyle: {
                                                            "padding-left":
                                                              "20px",
                                                            "padding-bottom":
                                                              "0px"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "custom-control "
                                                            },
                                                            [
                                                              _vm._m(9),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "search-padd float-left col-7"
                                                                },
                                                                [
                                                                  _c(
                                                                    "select",
                                                                    {
                                                                      directives: [
                                                                        {
                                                                          name:
                                                                            "model",
                                                                          rawName:
                                                                            "v-model",
                                                                          value:
                                                                            _vm.frequency,
                                                                          expression:
                                                                            "frequency"
                                                                        }
                                                                      ],
                                                                      staticClass:
                                                                        "custom-select",
                                                                      attrs: {
                                                                        id:
                                                                          "frequency",
                                                                        name:
                                                                          "frequency"
                                                                      },
                                                                      on: {
                                                                        change: [
                                                                          function(
                                                                            $event
                                                                          ) {
                                                                            var $$selectedVal = Array.prototype.filter
                                                                              .call(
                                                                                $event
                                                                                  .target
                                                                                  .options,
                                                                                function(
                                                                                  o
                                                                                ) {
                                                                                  return o.selected
                                                                                }
                                                                              )
                                                                              .map(
                                                                                function(
                                                                                  o
                                                                                ) {
                                                                                  var val =
                                                                                    "_value" in
                                                                                    o
                                                                                      ? o._value
                                                                                      : o.value
                                                                                  return val
                                                                                }
                                                                              )
                                                                            _vm.frequency = $event
                                                                              .target
                                                                              .multiple
                                                                              ? $$selectedVal
                                                                              : $$selectedVal[0]
                                                                          },
                                                                          function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.changeUserFrequency()
                                                                          }
                                                                        ]
                                                                      }
                                                                    },
                                                                    _vm._l(
                                                                      _vm.frequency_options,
                                                                      function(
                                                                        item,
                                                                        index
                                                                      ) {
                                                                        return _c(
                                                                          "option",
                                                                          {
                                                                            key: index,
                                                                            domProps: {
                                                                              value:
                                                                                item.value
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                item.text
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("div", {
                                                                staticStyle: {
                                                                  clear: "both"
                                                                }
                                                              })
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm._m(10)
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ])
                                      ])
                                    ])
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", {
                              staticStyle: {
                                clear: "both",
                                "margin-bottom": "20px"
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6 pr-3 pr-xl-5" })
                        ]),
                        _vm._v(" "),
                        _c("div", {
                          staticStyle: {
                            clear: "both",
                            "margin-bottom": "20px"
                          }
                        })
                      ])
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("EditProfile", {
        ref: "edit_profile_form",
        attrs: { isModalVisible: _vm.isEditProfileModalVisible },
        on: {
          close: function($event) {
            _vm.isEditProfileModalVisible = false
          }
        }
      }),
      _vm._v(" "),
      _c("UpdatePassword", {
        ref: "update_password_form",
        attrs: { isModalVisible: _vm.isUpdatePasswordModalVisible },
        on: {
          close: function($event) {
            _vm.isUpdatePasswordModalVisible = false
          }
        }
      }),
      _vm._v(" "),
      _c(
        "PreferenceUpdateConfirmModal",
        {
          attrs: { isModalVisible: _vm.isPrefereceUpdateConfirmModalVisible },
          on: {
            close: function($event) {
              return _vm.closeConfirm()
            }
          }
        },
        [
          _vm.loading
            ? _c("span", { staticClass: "pull-right text-danger" }, [
                _vm._v("\n      Loading...\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sub-heading",
              staticStyle: { "margin-left": "0" },
              attrs: { slot: "header" },
              slot: "header"
            },
            [_vm._v(_vm._s(_vm.modal_title))]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "body" }, slot: "body" }, [
            _c("span", { domProps: { innerHTML: _vm._s(_vm.modal_message) } })
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-12 p-0",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("div", { staticClass: "col-6 float-left p-0" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-sm ma-white-btn1",
                    on: {
                      click: function($event) {
                        return _vm.closeConfirm()
                      }
                    }
                  },
                  [_vm._v("Cancel")]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-6 float-left p-0 text-align-right" },
                [
                  _vm.buttonTitle == "Update"
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-sm ma-blue-btn1",
                          on: {
                            click: function($event) {
                              return _vm.onFrequencySubmit()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.buttonTitle))]
                      )
                    : _c(
                        "button",
                        {
                          staticClass: "btn btn-sm ma-blue-btn1",
                          on: {
                            click: function($event) {
                              return _vm.onSubscribeNewsSubmit()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.buttonTitle))]
                      )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticStyle: { clear: "both" } })
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "SuccessConfirmModal",
        {
          attrs: { isModalVisible: _vm.isSuccessConfirmModalVisible },
          on: {
            close: function($event) {
              return _vm.closeSuccessConfirm()
            }
          }
        },
        [
          _vm.loading
            ? _c("span", { staticClass: "pull-right text-danger" }, [
                _vm._v("\n      Loading...\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sub-heading",
              staticStyle: { "margin-left": "0" },
              attrs: { slot: "header" },
              slot: "header"
            },
            [_vm._v(_vm._s(_vm.modal_success_title))]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "body" }, slot: "body" }, [
            _c("span", {
              domProps: { innerHTML: _vm._s(_vm.modal_success_message) }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-12 p-0",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("div", { staticClass: "col-12 text-center" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-sm ma-blue-btn1",
                    on: {
                      click: function($event) {
                        return _vm.closeSuccessConfirm()
                      }
                    }
                  },
                  [_vm._v("Close")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticStyle: { clear: "both" } })
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "MultifactorAuthenticationConfirmModal",
        {
          attrs: {
            isModalVisible: _vm.isMultifactorAuthenticationConfirmModal
          },
          on: {
            close: function($event) {
              return _vm.closeAuthConfirm()
            }
          }
        },
        [
          _vm.loading
            ? _c("span", { staticClass: "pull-right text-danger" }, [
                _vm._v("\n      Loading...\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sub-heading",
              staticStyle: { "margin-left": "-15px" },
              attrs: { slot: "header" },
              slot: "header"
            },
            [_vm._v("Enabling Multifactor Authentication")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "body" }, slot: "body" },
            [
              _c(
                "b-alert",
                {
                  attrs: {
                    show: _vm.dismissAuthCountDown,
                    dismissible: "",
                    variant: "success"
                  },
                  on: {
                    dismissed: function($event) {
                      _vm.dismissAuthCountDown = 0
                    },
                    "dismiss-count-down": _vm.countDownAuthChanged
                  }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.success_auth_message) +
                      "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "b-alert",
                {
                  attrs: {
                    show: _vm.dismissCountWarningDown,
                    dismissible: "",
                    variant: "danger"
                  },
                  on: {
                    dismissed: function($event) {
                      _vm.dismissCountWarningDown = 0
                    },
                    "dismiss-count-down": _vm.countDownWarningChanged
                  }
                },
                [
                  _vm._v(
                    "\n          " + _vm._s(_vm.warning_message) + "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-12",
                  staticStyle: {
                    "font-size": "13px",
                    "padding-bottom": "5px",
                    "margin-left": "-33px"
                  }
                },
                [
                  _vm._v(
                    "\n            Please enter the 6 digit code sent to your email.\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-12",
                  staticStyle: { "margin-left": "-8px" }
                },
                [
                  _c("SimpleOtpInput", {
                    attrs: {
                      inputProps: {
                        type: "number",
                        min: 0
                      }
                    },
                    on: { change: _vm.handleChange },
                    model: {
                      value: _vm.auth_code,
                      callback: function($$v) {
                        _vm.auth_code = $$v
                      },
                      expression: "auth_code"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-7 text-center",
                  staticStyle: {
                    margin: "0px auto",
                    "margin-top": "20px",
                    color: "#00ACEE",
                    cursor: "pointer"
                  },
                  on: {
                    click: function($event) {
                      return _vm.resendCode()
                    }
                  }
                },
                [_vm._v("\n            Did not receive a code?\n        ")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-12 p-0",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("div", { staticClass: "col-6 float-left p-0" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-sm ma-white-btn1",
                    staticStyle: { "margin-left": "-15px" },
                    on: {
                      click: function($event) {
                        return _vm.closeAuthConfirm()
                      }
                    }
                  },
                  [_vm._v("Cancel")]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-6 float-left p-0 text-align-right" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm ma-blue-btn1",
                      class: _vm.disable_verify_btn
                        ? "btn-blue-disabled"
                        : "btn-blue",
                      staticStyle: { "margin-right": "-23px" },
                      attrs: { disabled: _vm.disable_verify_btn },
                      on: {
                        click: function($event) {
                          return _vm.verifyCode()
                        }
                      }
                    },
                    [_vm._v("Enable")]
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticStyle: { clear: "both" } })
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "ChangePasswordConfirmModal",
        {
          attrs: { isModalVisible: _vm.isChangePasswordConfirmModal },
          on: {
            close: function($event) {
              return _vm.closeCPAuthConfirm()
            }
          }
        },
        [
          _vm.loading
            ? _c("span", { staticClass: "pull-right text-danger" }, [
                _vm._v("\n      Loading...\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sub-heading",
              staticStyle: { "margin-left": "-15px" },
              attrs: { slot: "header" },
              slot: "header"
            },
            [_vm._v("Change Password Authenication")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "body" }, slot: "body" },
            [
              _c(
                "b-alert",
                {
                  attrs: {
                    show: _vm.dismissCPAuthCountDown,
                    dismissible: "",
                    variant: "success"
                  },
                  on: {
                    dismissed: function($event) {
                      _vm.dismissCPAuthCountDown = 0
                    },
                    "dismiss-count-down": _vm.countDownCPAuthChanged
                  }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.success_cp_auth_message) +
                      "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "b-alert",
                {
                  attrs: {
                    show: _vm.dismissCountCPWarningDown,
                    dismissible: "",
                    variant: "danger"
                  },
                  on: {
                    dismissed: function($event) {
                      _vm.dismissCountCPWarningDown = 0
                    },
                    "dismiss-count-down": _vm.countDownCPWarningChanged
                  }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.warning_cp_message) +
                      "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-12",
                  staticStyle: {
                    "font-size": "13px",
                    "padding-bottom": "5px",
                    "margin-left": "-33px"
                  }
                },
                [
                  _vm._v(
                    "\n            Please enter the 6 digit code sent to your email.\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-12",
                  staticStyle: { "margin-left": "-8px" }
                },
                [
                  _c("SimpleOtpInput", {
                    attrs: {
                      inputProps: {
                        type: "number",
                        min: 0
                      }
                    },
                    on: { change: _vm.handleCPChange },
                    model: {
                      value: _vm.cp_auth_code,
                      callback: function($$v) {
                        _vm.cp_auth_code = $$v
                      },
                      expression: "cp_auth_code"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-7 text-center",
                  staticStyle: {
                    margin: "0px auto",
                    "margin-top": "20px",
                    color: "#00ACEE",
                    cursor: "pointer"
                  },
                  on: {
                    click: function($event) {
                      return _vm.resendCPCode()
                    }
                  }
                },
                [_vm._v("\n            Did not receive a code?\n        ")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-12 p-0",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("div", { staticClass: "col-6 float-left p-0" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-sm ma-white-btn1",
                    staticStyle: { "margin-left": "-15px" },
                    on: {
                      click: function($event) {
                        return _vm.closeCPAuthConfirm()
                      }
                    }
                  },
                  [_vm._v("Cancel")]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-6 float-left p-0 text-align-right" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm ma-blue-btn1",
                      class: _vm.disable_cp_verify_btn
                        ? "btn-blue-disabled"
                        : "btn-blue",
                      staticStyle: { "margin-right": "-23px" },
                      attrs: { disabled: _vm.disable_cp_verify_btn },
                      on: {
                        click: function($event) {
                          return _vm.verifyCPCode()
                        }
                      }
                    },
                    [_vm._v("Verify")]
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticStyle: { clear: "both" } })
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", [
        _c(
          "h3",
          {
            staticClass: "heading text-uppercase mb-3",
            staticStyle: { "padding-left": "10px" }
          },
          [_vm._v("My Profile")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-6 col-sm-9 col-md-9 col-lg-10 col-xl-9" },
      [
        _c(
          "div",
          {
            staticClass: "h6 mb-0 font-weight-bold",
            staticStyle: { "padding-bottom": "20px" }
          },
          [_vm._v("Information")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-4" }, [
      _c("div", { staticClass: "label_txt" }, [_vm._v("Name: ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-4 " }, [
      _c("div", { staticClass: "label_txt" }, [_vm._v("Email Address: ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-4" }, [
      _c("div", { staticClass: "label_txt" }, [_vm._v("Phone Number: ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-6 col-sm-9 col-md-9 col-lg-10 col-xl-9" },
      [
        _c(
          "div",
          {
            staticClass: "h6 mb-0 font-weight-bold",
            staticStyle: { "padding-bottom": "20px" }
          },
          [_vm._v("Change Password")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row grid_row" }, [
      _c("div", { staticClass: "col-6 col-sm-9 col-md-9 col-lg-10 col-xl-9" }, [
        _c("div", { staticClass: "label_txt" }, [_vm._v("Password")])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-6 col-sm-3 col-md-3 col-lg-2 col-xl-3 text-right" },
        [_vm._v("\n                        ********\n                      ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-6 col-sm-9 col-md-9 col-lg-10 col-xl-9" },
      [
        _c("div", { staticClass: "label_txt" }, [
          _vm._v("Enable Multifactor Authentication")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-6 col-sm-9 col-md-9 col-lg-10 col-xl-9" }, [
        _c(
          "div",
          {
            staticClass: "h6 mb-0 font-weight-bold",
            staticStyle: { "padding-bottom": "20px" }
          },
          [_vm._v("Security & Preferences")]
        )
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "col-6 col-sm-3 col-md-3 col-lg-2 col-xl-3 text-right"
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-5 p-0 float-left" }, [
      _c(
        "label",
        {
          staticClass: "preference-heading",
          staticStyle: { "padding-top": "2px" },
          attrs: { for: "notification" }
        },
        [_vm._v("Mentoring support communication")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols",
        staticStyle: { "padding-left": "45px", "padding-bottom": "5px" }
      },
      [
        _c(
          "label",
          {
            staticClass: "preference-heading",
            staticStyle: {
              "padding-top": "0px",
              "font-size": "11px",
              "font-style": "italic",
              color: "#B1B8BA"
            },
            attrs: { for: "notification" }
          },
          [
            _vm._v(
              "A successful mentoring program is based on consistent communication Mentor Mentee recommends your communication frequency remain on default."
            )
          ]
        )
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8475b5b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8475b5b4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/my_profile.vue
// module id = null
// module chunks = 